module.exports = __webpack_public_path__ + "img/5.22c392c0.jpg";